module.exports = __webpack_public_path__ + "media/components/weather-icon/static/nightclear@2-8656f58d3bc1f379e7ee9c5c5400745d.png";